(function () {
  'use strict';

  // Keep this file parseable in ES5 browsers. An array is sufficient here because
  // the number of initialized sections on a page is small.
  var initialized = [];

  function hasInitialized(root) {
    var index;

    for (index = 0; index < initialized.length; index += 1) {
      if (initialized[index] === root) return true;
    }

    return false;
  }

  function markInitialized(root) {
    if (!hasInitialized(root)) initialized.push(root);
  }

  function toArray(items) {
    var result = [];
    var index;

    for (index = 0; index < items.length; index += 1) {
      result.push(items[index]);
    }

    return result;
  }

  function forEachItem(items, callback) {
    var index;

    for (index = 0; index < items.length; index += 1) {
      callback(items[index], index);
    }
  }

  function indexOfItem(items, item) {
    var index;

    for (index = 0; index < items.length; index += 1) {
      if (items[index] === item) return index;
    }

    return -1;
  }

  function getData(element, name) {
    var value = element.getAttribute('data-' + name);
    return value === null ? void 0 : value;
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && isFinite(value);
  }

  function setClass(element, className, enabled) {
    var classes;

    if (element.classList) {
      if (enabled) element.classList.add(className);
      else element.classList.remove(className);
      return;
    }

    classes = (' ' + element.className + ' ').replace(/\s+/g, ' ');

    if (enabled && classes.indexOf(' ' + className + ' ') === -1) {
      element.className += (element.className ? ' ' : '') + className;
    } else if (!enabled) {
      element.className = classes.replace(' ' + className + ' ', ' ').replace(/^\s+|\s+$/g, '');
    }
  }

  function matches(element, selector) {
    var elementPrototype;
    var nativeMatches;
    var parent;
    var matchesList;
    var index;

    if (!element || element.nodeType !== 1) return false;

    elementPrototype = window.Element && window.Element.prototype;
    nativeMatches = elementPrototype && (
      elementPrototype.matches ||
      elementPrototype.msMatchesSelector ||
      elementPrototype.webkitMatchesSelector ||
      elementPrototype.mozMatchesSelector
    );

    if (nativeMatches) return nativeMatches.call(element, selector);

    parent = element.parentNode || document;
    matchesList = parent.querySelectorAll(selector);

    for (index = 0; index < matchesList.length; index += 1) {
      if (matchesList[index] === element) return true;
    }

    return false;
  }

  function closest(element, selector) {
    if (element && element.nodeType !== 1) element = element.parentNode;

    while (element && element.nodeType === 1) {
      if (matches(element, selector)) return element;
      element = element.parentNode;
    }

    return null;
  }

  function isDesktop() {
    return !window.matchMedia || window.matchMedia('(min-width: 750px)').matches;
  }

  function initToolkitSwiper(root) {
    var swiperEl;
    var scrollbarEl;
    var slides;
    var autoplay;
    var delay;
    var swiperInstance;

    if (hasInitialized(root)) return;

    swiperEl = root.querySelector('.pro-stylist-toolkit__swiper');
    if (!swiperEl) return;

    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(function () {
        initToolkitSwiper(root);
      }, 100);
      return;
    }

    slides = swiperEl.querySelectorAll('.swiper-slide');
    scrollbarEl = root.querySelector('.pro-stylist-toolkit__scrollbar');

    if (slides.length <= 1) {
      if (scrollbarEl) scrollbarEl.style.display = 'none';
      markInitialized(root);
      return;
    }

    markInitialized(root);

    autoplay = getData(root, 'autoplay') === 'true';
    delay = parseInt(getData(root, 'autoplay-delay'), 10) || 4000;

    swiperInstance = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 600,
      loop: false,
      autoplay: autoplay ? { delay: delay, disableOnInteraction: false } : false,
      scrollbar: scrollbarEl ? {
        el: scrollbarEl,
        draggable: true,
        dragSize: 'auto'
      } : false
    });

    root._swiper = swiperInstance;
  }

  function initMediaAwards(root) {
    var thumbsEl;
    var mainEl;
    var cells;
    var blockCount;
    var requestedSlide;
    var initialSlide;
    var autoplay;
    var autoplayDelay;
    var thumbsSwiper;
    var mainSwiper;

    if (hasInitialized(root)) return;

    thumbsEl = root.querySelector('.media-awards-thumbs-swiper');
    mainEl = root.querySelector('.media-awards__slider');
    if (!thumbsEl || !mainEl) return;

    if (typeof window.Swiper === 'undefined') {
      if (getData(root, 'pro-stylist-media-awards-waiting') === 'true') return;

      root.setAttribute('data-pro-stylist-media-awards-waiting', 'true');
      window.setTimeout(function () {
        root.removeAttribute('data-pro-stylist-media-awards-waiting');
        initMediaAwards(root);
      }, 100);
      return;
    }

    cells = toArray(root.querySelectorAll('.media-awards-thumbs-swiper .carousel-cell'));
    blockCount = cells.length;
    if (blockCount === 0) return;

    markInitialized(root);

    requestedSlide = parseInt(getData(root, 'initial-slide'), 10) || 1;
    initialSlide = Math.min(Math.max(requestedSlide - 1, 0), blockCount - 1);
    autoplay = getData(root, 'autoplay') === 'true';
    autoplayDelay = parseInt(getData(root, 'autoplay-delay'), 10) || 3500;

    thumbsSwiper = new window.Swiper(thumbsEl, {
      spaceBetween: 20,
      slidesPerView: 3,
      centeredSlides: true,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          slidesPerView: blockCount,
          centeredSlides: false,
          spaceBetween: 20
        }
      }
    });

    mainSwiper = new window.Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: blockCount > 1,
      watchSlidesProgress: true,
      autoplay: autoplay ? { delay: autoplayDelay, disableOnInteraction: false } : false,
      thumbs: { swiper: thumbsSwiper },
      pagination: {
        el: mainEl.querySelector('.media-awards-pagination'),
        clickable: true
      }
    });

    function setActiveLogo(index) {
      forEachItem(cells, function (cell, cellIndex) {
        var selected = cellIndex === index;
        setClass(cell, 'is-selected', selected);
        cell.setAttribute('aria-pressed', String(selected));
      });
    }

    function showSlide(index, speed) {
      if (typeof speed === 'undefined') speed = 400;

      if (mainSwiper.params.loop) {
        mainSwiper.slideToLoop(index, speed);
      } else {
        mainSwiper.slideTo(index, speed);
      }

      setActiveLogo(index);
    }

    mainSwiper.on('slideChange', function () {
      setActiveLogo(mainSwiper.realIndex);
    });

    if (initialSlide > 0) showSlide(initialSlide, 0);
    else setActiveLogo(0);

    forEachItem(cells, function (cell, index) {
      cell.addEventListener('click', function () {
        showSlide(index);
      });
      cell.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        if (mainSwiper.autoplay) mainSwiper.autoplay.stop();
        showSlide(index);
      });
      cell.addEventListener('focus', function () {
        showSlide(index);
      });
      cell.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        if (autoplay && mainSwiper.autoplay) mainSwiper.autoplay.start();
      });
    });

    root._proStylistMediaAwards = mainSwiper;
  }

  function initQuoteCarousel(root) {
    var quotes;
    var dots;
    var initialIndex;

    if (hasInitialized(root)) return;
    markInitialized(root);

    quotes = toArray(root.querySelectorAll('[data-pro-stylist-quote]'));
    dots = toArray(root.querySelectorAll('[data-pro-stylist-quote-dot]'));
    if (quotes.length < 2 || dots.length === 0) return;

    function setActive(index) {
      var nextIndex = Math.max(0, Math.min(index, quotes.length - 1));

      forEachItem(quotes, function (quote, quoteIndex) {
        setClass(quote, 'is-active', quoteIndex === nextIndex);
      });

      forEachItem(dots, function (dot, dotIndex) {
        var active = dotIndex === nextIndex;
        setClass(dot, 'is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    forEachItem(dots, function (dot) {
      dot.addEventListener('click', function () {
        setActive(Number(getData(dot, 'index')) || 0);
      });
    });

    initialIndex = Number(getData(root, 'pro-stylist-initial-index'));
    setActive(isFiniteNumber(initialIndex) ? initialIndex : 0);
  }

  function initCollectiveBanner(root) {
    var videos;

    if (hasInitialized(root)) return;
    markInitialized(root);

    videos = toArray(root.querySelectorAll('video'));
    if (videos.length === 0) return;

    forEachItem(videos, function (video) {
      video.muted = true;
      var playPromise = video.play();

      if (playPromise !== void 0 && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          if ('IntersectionObserver' in window) {
            var observer = new window.IntersectionObserver(function (entries) {
              forEachItem(entries, function (entry) {
                if (entry.isIntersecting) {
                  video.play().catch(function () {});
                  observer.unobserve(video);
                }
              });
            }, { threshold: 0.1 });
            observer.observe(video);
          }
        });
      }
    });
  }

  function init(scope) {
    if (typeof scope === 'undefined') scope = document;

    forEachItem(scope.querySelectorAll('.pro-stylist-collective-banner'), initCollectiveBanner);
    forEachItem(scope.querySelectorAll('[data-pro-stylist-quotes]'), initQuoteCarousel);
    forEachItem(scope.querySelectorAll('[data-pro-stylist-toolkit-slider]'), initToolkitSwiper);
    forEachItem(scope.querySelectorAll('[data-pro-stylist-media-awards]'), initMediaAwards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || event.srcElement);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target || event.srcElement;
    var section = closest(target, '[data-pro-stylist-toolkit-slider]');
    var slideIndex;
    var mediaAwards;
    var selectedCell;

    if (section && section._swiper) {
      slideIndex = indexOfItem(toArray(section.querySelectorAll('.swiper-slide')), target);
      if (slideIndex >= 0) {
        section._swiper.slideTo(slideIndex);
      }
    }

    mediaAwards = closest(target, '[data-pro-stylist-media-awards]');
    if (mediaAwards && mediaAwards._proStylistMediaAwards) {
      selectedCell = closest(target, '.carousel-cell');
      slideIndex = indexOfItem(toArray(mediaAwards.querySelectorAll('.carousel-cell')), selectedCell);
      if (slideIndex >= 0) {
        if (mediaAwards._proStylistMediaAwards.params.loop) {
          mediaAwards._proStylistMediaAwards.slideToLoop(slideIndex);
        } else {
          mediaAwards._proStylistMediaAwards.slideTo(slideIndex);
        }
      }
    }
  });
})();
